import React, { useCallback, useMemo } from 'react';
import Checkbox from '../../../../../common/CustomCheckbox';
import { faOnListFilterApply, faOnListFilterRemove } from '../analytics-services';

const RowSection = ({
  filterOption,
  filterStats,
  handleOptionClick,
  appliedValues,
  singleSelect,
  filterUrlParam,
}) => {
  const count = useMemo(() => {
    const currentFilterStats = filterStats?.find(
      stat => stat.filterValue === filterOption?.uniqueId
    );

    return currentFilterStats?.packageCount;
  }, [filterOption, filterStats]);

  const isApplied = useMemo(
    () =>
      appliedValues?.indexOf(filterOption?.uniqueId) > -1 ||
      appliedValues?.indexOf(filterOption?.uniqueId?.toLowerCase?.()) > -1,
    [appliedValues, filterOption?.uniqueId]
  );

  const handleApplyFilter = useCallback(() => {
    if (singleSelect) {
      if (isApplied) {
        faOnListFilterRemove(filterUrlParam, filterOption?.uniqueId);
        handleOptionClick([], { prop54: `filter_remove_ui_<urlParam>_${filterOption?.uniqueId}` });
      } else {
        faOnListFilterApply(filterUrlParam, filterOption?.uniqueId);
        handleOptionClick([filterOption?.uniqueId], {
          prop54: `filter_apply_ui_<urlParam>_${filterOption?.uniqueId}`,
        });
      }
    } else if (isApplied) {
      faOnListFilterRemove(filterUrlParam, filterOption?.uniqueId);
      handleOptionClick(
        appliedValues.filter(value => value !== filterOption?.uniqueId),
        { prop54: `filter_remove_ui_<urlParam>_${filterOption?.uniqueId}` }
      );
    } else {
      faOnListFilterApply(filterUrlParam, filterOption?.uniqueId);
      handleOptionClick([...appliedValues, filterOption?.uniqueId], {
        prop54: `filter_apply_ui_<urlParam>_${filterOption?.uniqueId}`,
      });
    }
  }, [isApplied, filterOption?.uniqueId, appliedValues]);

  return (
    <label className={`filterListWrap ${isApplied ? 'active' : ''} ${count > 0 ? '' : 'disabled'}`}>
      <Checkbox
        onClick={handleApplyFilter}
        checked={isApplied}
        inputName={filterOption?.uniqueId}
      />
      <div className="filterListLeft">
        <span className="filterText">{filterOption?.filterText}</span>
      </div>
      <span>({count ?? 0})</span>
    </label>
  );
};

export default RowSection;
